<template>
    <b-form-input
        ref="input"
        v-model="formattedValue"
        v-bind="$attrs"
        @input="updateValue"
        @focus="selectAll"
        @blur="blurEvent"
    />
</template>
<script>
export default {
    name: "NumberInputVue",
    props: {
        value: { type: Number, default: 0 }
    },
    data() {
        return {
            formattedValue: this.value,
            hasFocus: false
        };
    },
    watch: {
        value() {
            this.formatValue();
        }
    },
    mounted: function() {
        this.formatValue();
    },
    methods: {
        updateValue() {
            let num = parseFloat(this.formattedValue.replace(/[^0-9.,]/g, "").replace(/,/, "."));
            console.log(num);
            if (num !== 0) {
                //this.$refs.input.vModelValue = ;
                this.$emit("input", num);
            } else {
                //this.$refs.input.vModelValue = null;
                this.$emit("input", 0);
            }
        },
        blurEvent() {
            this.hasFocus = false;
            this.formatValue();
        },
        formatValue() {
            if (!this.hasFocus) {
                const numberToFormat = this.value;
                this.formattedValue = !numberToFormat
                    ? ""
                    : (numberToFormat.toFixed(2) + "").replace(".", ",");
            }
        },
        selectAll() {
            this.hasFocus = true;
            // Workaround for Safari bug
            // http://stackoverflow.com/questions/1269722/selecting-text-on-focus-using-jquery-not-working-in-safari-and-chrome
            let target = this.$refs.input;
            setTimeout(function() {
                target.select();
            }, 0);
        }
    }
};
</script>
<style scoped>
input {
    text-align: right;
}
</style>
